import { createAction } from 'typesafe-actions';

import { Actions } from './constants';

interface EnterBackstageParams extends $TSFixMe {}

type EnterBackstagePayload = EnterBackstageParams;

/**
 * Action to signal that the user is entering a backstage page
 * @param {object} payload - nextState data
 */
export const enterBackstage = createAction(
  Actions.ENTER_BACKSTAGE,
  (payload: EnterBackstageParams) => payload,
)<EnterBackstagePayload>();
export type EnterBackstageAction = ReturnType<typeof enterBackstage>;

/**
 * Action to signal that the user is leaving a backstage page
 */

export const leaveBackstage = createAction(Actions.LEAVE_BACKSTAGE)();
export type LeaveBackstageAction = ReturnType<typeof leaveBackstage>;
